import React from 'react';
import { useTranslations } from '../../../locales/useTranslations';

const ZeroTrustVpnProcess = () => {
  const { t } = useTranslations();
  const steps = [1, 2, 3, 4].map((n) => ({
    title: t(`managedServices_zeroTrustVpn_process_step${n}_title`),
    desc: t(`managedServices_zeroTrustVpn_process_step${n}_desc`),
  }));

  return (
    <section className="ms-section ms-section--process">
      <div className="container">
        <div className="ms-section-header ms-section-header--center">
          <span className="ms-section__badge">{t('managedServices_zeroTrustVpn_process_badge')}</span>
          <h2 className="ms-section__title">{t('managedServices_zeroTrustVpn_process_title')}</h2>
        </div>
        <div className="row ms-process-row">
          {steps.map((step, index) => (
            <div key={index} className="col-lg-3 col-md-6 mb-4">
              <div className="ms-process-step ms-process-step--card">
                <div className="ms-process-step__num">{index + 1}</div>
                <h4>{step.title}</h4>
                <p>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ZeroTrustVpnProcess;
